export const lwaTableButtonStyles = {
    fontSize: '9px',
};
